import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-param-reassign */

/* eslint-disable prefer-destructuring */

/* eslint-disable consistent-return */
import { EAC, EAO, INAForm, NVRForm } from './constants';
import { formatPostDate } from './formatters';
import { hasSelectedVisitAttribute, isVisitAttributeSelected } from './utils';
import defaults from './translationDefaults/en';
export const approve = 'approve';
export const download = 'download';
export const redownload = 'redownload';
export const unapprove = 'unapprove';
export const accepted = 'accept';
export const rejected = 'reject';
export const unaccept = 'unaccept';
export const discard = 'discard';
export const INA = 'INA';
export const NVR = 'NVR';
export const SIA = 'SIA';
export const SFV = 'SFV';
export const NFV = 'NFV'; // Admit
// atts.

export const ADM = 'ADM';
export const HAD = 'HAD'; // Hope Admit

export const HADD = 'HADD'; // Admit declined

export const HADSF = 'HADSF'; // Admit symptom followup

export const HADSD = 'HADSD'; // Admit symptom followup declined
// status

export const Admit = 'admit';
export const admitVisitSubmitted = 'admit_visit_submitted';
export const admitSFVSubmitted = 'admit_sfv_submitted';
export const admitApproved = 'admit_approved';
export const admitUnApproved = 'admit_unapproved';
export const admitDownloaded = 'admit_downloaded';
export const admitCMSAccepted = 'admit_cms_accepted';
export const admitCMSRejected = 'admit_cms_rejected';
export const admitCMSUnaccepted = 'admit_cms_unaccepted';
/**
 * Pre-visit waiting labels from the HOPE patient DTO `status` field.
 * A declined milestone may still be reopened while status is any of these
 * (including earlier-in-sequence waits, e.g. HUV2 still "Waiting HUV1 Visit").
 * Do not include post-approval waits like "Waiting CMS Accepted".
 */

const preVisitWaitingStatusLabels = ['Waiting Admit Visit', 'Waiting HUV1 Visit', 'Waiting HUV2 Visit'];
/** True when HOPE milestone status is still waiting on the visit (not CMS waits). */

export const isPreVisitWaitingStatus = status => {
  if (status == null || status === '') return false;
  const normalized = status.toLowerCase();
  return preVisitWaitingStatusLabels.some(label => label.toLowerCase() === normalized);
}; // HUV1
// atts.

export const HUV1 = 'HUV1';
export const HUV1D = 'HUV1D';
export const HU1SF = 'HU1SF'; // Huv1

export const HU1SD = 'HU1SD'; // status

export const huv1NVRSubmitted = 'huv1_nvr_submitted';
export const huv1SFVSubmitted = 'huv1_sfv_submitted';
export const huv1Approved = 'huv1_approved';
export const huv1UnApproved = 'huv1_unapproved';
export const huv1Downloaded = 'huv1_downloaded';
export const huv1CMSAccepted = 'huv1_cms_accepted';
export const huv1CMSRejected = 'huv1_cms_rejected';
export const huv1CMSUnaccepted = 'huv1_cms_unaccepted';
export const huv1Discarded = 'huv1_discarded'; // HUV2
// atts.

export const HUV2 = 'HUV2';
export const HU2SF = 'HU2SF';
export const HUV2D = 'HUV2D';
export const HU2SD = 'HU2SD'; // status

export const huv2NVRSubmitted = 'huv2_nvr_submitted';
export const huv2SFVSubmitted = 'huv2_sfv_submitted';
export const huv2Approved = 'huv2_approved';
export const huv2UnApproved = 'huv2_unapproved';
export const huv2Downloaded = 'huv2_downloaded';
export const huv2CMSAccepted = 'huv2_cms_accepted';
export const huv2CMSRejected = 'huv2_cms_rejected';
export const huv2CMSUnaccepted = 'huv2_cms_unaccepted';
export const huv2Discarded = 'huv2_discarded'; // DIS

export const DIS = 'DIS'; // status

export const dischargeApproved = 'discharge_approved';
export const dischargeUnApproved = 'discharge_unapproved';
export const dischargeDownloaded = 'discharge_downloaded';
export const dischargeCMSAccepted = 'discharge_cms_accepted';
export const dischargeCMSRejected = 'discharge_cms_rejected';
export const dischargeCMSUnaccepted = 'discharge_cms_unaccepted'; // props for each milestone from the backend

export const AdmitData = 'admitdata'; // TODO needs to be fixed on the backend

export const HUV1Data = 'huv1Data';
export const HUV2Data = 'huv2data';
export const DischargeData = 'dischargedata'; // HOPE timing — align with workflow-server HopeConstants.java / HOPE_TIMING_RULES.md

export const HOPE_HUV1_START_DOS = 6;
export const HOPE_HUV2_START_DOS = 16;
export const HUV1_DAYS_TO_DOCUMENT = 15;
export const HUV2_DAYS_TO_DOCUMENT = 30;
export const isForAdmit = 'isforadmit';
export const isForHUV1 = 'isforhuv1';
export const isForHUV2 = 'isforhuv2';
export const isForDischarge = 'isfordischarge'; // SIA symptom values from the backend
// combined with UI defaults below

export const pain = 'pain';
export const shortBreath = 'shortBreath';
export const anxiety = 'anxiety';
export const nausea = 'nausea';
export const vomiting = 'vomiting';
export const diarrhea = 'diarrhea';
export const constipation = 'constipation';
export const agitation = 'agitation';
const INAFormKey = 'hz-v1-ina';
const INAPedFormKey = 'hz-v1-init-nursing-assess-pediatric';
const INAESFormKey = 'hz-v1-es-ina';
const INAPedESFormKey = 'hz-v1-es-init-nursing-assess-pediatric';
const NVRFormKey = 'hz-v1-nvr';
const NVRPedFormKey = 'hz-v1-pediatric-nurse';
const NVRESFormKey = 'hz-v1-es-nvr';
const NVRPedESFormKey = 'hz-v1-es-pediatric-nurse'; // Approved Milestones statuses

const approvedMilestoneStatuses = ['Ready for download', 'Sent and Accepted', 'Waiting CMS Accepted', 'CMS Rejected', 'Complete', 'Unaccepted'];
export const HopeADMFormKeys = [INAFormKey, INAPedFormKey, INAESFormKey, INAPedESFormKey];
export const HopeHUVFormKeys = [NVRFormKey, NVRPedFormKey, NVRESFormKey, NVRPedESFormKey];
export function isHopeNvrOrInaFormKey(formKey) {
  if (formKey == null || formKey === '') return false;
  const s = String(formKey).toLowerCase();
  return s.includes('nvr') || s.includes('ina');
}
const HUV1_HOPE_ATT_ID = -15;
const HUV2_HOPE_ATT_ID = -16;
/** Returns true if any action in the possibleactions array has actn === 'unapprove'. */

const canUnapprove = milestone => Array.isArray(milestone === null || milestone === void 0 ? void 0 : milestone.possibleactions) && milestone.possibleactions.some(a => a.actn === unapprove);
/**
 * Returns true when the milestone is at a terminal post-CMS state where the
 * workflow server no longer offers 'unapprove' as an action (e.g. "Sent and
 * Accepted", "Complete"). These states must be checked separately because
 * possibleactions is either empty or contains only 'unaccept' at that point.
 */


const isTerminalHopeState = milestone => {
  const s = milestone === null || milestone === void 0 ? void 0 : milestone.status;
  return s === 'Sent and Accepted' || s === 'Complete';
};
/** True when the HOPE milestone is approved or at any post-approval state. */


const milestoneApprovedOrBeyond = milestone => canUnapprove(milestone) || isTerminalHopeState(milestone);
/**
 * True when the HOPE milestone linked to this form has been approved (or is at any
 * post-approval CMS state) — i.e. the Edit option should be hidden.
 *
 * Two complementary signals are used:
 *   1. possibleactions contains 'unapprove' — present from approved through
 *      "Waiting CMS Accepted" / "CMS Rejected".
 *   2. milestone status is a terminal string ("Sent and Accepted", "Complete") —
 *      workflow removes 'unapprove' once CMS fully accepts, so possibleactions
 *      alone is not sufficient.
 *
 * visitId disambiguates NVR forms: match against the milestone's patientvisit_id
 * rather than blocking Edit if either HUV milestone is approved.
 */


export function isHopeMilestoneApproved(formKey, hopeEvent, acceptedAtts, visitId) {
  if (!hopeEvent || !formKey) {
    return false;
  }

  const key = String(formKey).toLowerCase();
  const isIna = HopeADMFormKeys.some(k => key.includes(k.toLowerCase())) || key.includes('ina') && !key.includes('nvr');
  const isHuv1 = acceptedAtts.some(a => a.id === HUV1_HOPE_ATT_ID);
  const isHuv2 = acceptedAtts.some(a => a.id === HUV2_HOPE_ATT_ID);

  if (isIna) {
    return milestoneApprovedOrBeyond(hopeEvent.admitdata);
  }

  if (isHuv1) {
    return milestoneApprovedOrBeyond(hopeEvent.huv1Data);
  }

  if (isHuv2) {
    return milestoneApprovedOrBeyond(hopeEvent.huv2data);
  }

  if (key.includes('nvr')) {
    var _huv1Data, _huv2data;

    const huv1VisitId = (_huv1Data = hopeEvent.huv1Data) === null || _huv1Data === void 0 ? void 0 : _huv1Data.patientvisit_id;
    const huv2VisitId = (_huv2data = hopeEvent.huv2data) === null || _huv2data === void 0 ? void 0 : _huv2data.patientvisit_id;

    if (visitId && huv1VisitId && visitId === String(huv1VisitId)) {
      return milestoneApprovedOrBeyond(hopeEvent.huv1Data);
    }

    if (visitId && huv2VisitId && visitId === String(huv2VisitId)) {
      return milestoneApprovedOrBeyond(hopeEvent.huv2data);
    } // No visit ID match — conservatively block Edit if either milestone is approved.


    return milestoneApprovedOrBeyond(hopeEvent.huv1Data) || milestoneApprovedOrBeyond(hopeEvent.huv2data);
  }

  return false;
}
export const hopeKeys = [AdmitData, HUV1Data, HUV2Data, DischargeData];
const hopeMilestones = [INA, HUV1, HUV2, SFV, NVR];
const {
  none,
  mild,
  moderate,
  severe,
  notApplicable
} = defaults.HopeCodes;
const {
  AdmitMilestone,
  HUVMilestone,
  SFVMilestone
} = defaults.HopeMilestones;
const {
  declined,
  unavailable,
  cantContact,
  noneOfTheAbove
} = defaults.HopeNoSFVReasons;
const {
  CompleteINA,
  CompleteSIA,
  Unapprove,
  RecordSFV,
  Approve,
  CompleteNVR,
  NoSFV,
  CompleteHUV1,
  CompleteHUV2,
  Download,
  RemoveAcceptance,
  Accept,
  Reject,
  Discard
} = defaults.HopeOptions;
const {
  error,
  warning,
  noError
} = defaults.HopeDocumentErrors; // <UI KEY>: <DTO PROP>

export const milestones = {
  [ADM]: AdmitMilestone,
  [HUV1]: HUVMilestone,
  [HUV2]: HUVMilestone,
  [SFV]: SFVMilestone
}; // <UI KEY>: <DTO PROP>

export const milestonesDTOProps = {
  [ADM]: AdmitData,
  [HUV1]: HUV1Data,
  [HUV2]: HUV2Data,
  [DIS]: DischargeData
};
/**
 * Declined-milestone codes (HADD, HUV1D, …) → DTO property on the HOPE patient
 * payload. Reopen is allowed when that property's `status` is any
 * `preVisitWaitingStatusLabels` value.
 */

const declinedMilestoneReopenConfigByCode = {
  [HADD]: {
    dtoPropertyKey: AdmitData
  },
  [HUV1D]: {
    dtoPropertyKey: HUV1Data
  },
  [HUV2D]: {
    dtoPropertyKey: HUV2Data
  }
};
export const acceptedMilestoneReopenConfigByCode = {
  [HAD]: AdmitData,
  HADSF: AdmitData,
  [HUV1]: HUV1Data,
  // Standalone SFV visit
  HUV1SF: HUV1Data,
  HU1SF: HUV1Data,
  [HUV2]: HUV2Data,
  HUV2SF: HUV2Data,
  HU2SF: HUV2Data
};

function readHopeDtoMilestoneStatus(hopePatientData, dtoPropertyKey) {
  const payload = hopePatientData[dtoPropertyKey];

  if (payload == null) {
    return undefined;
  }

  if (Array.isArray(payload)) {
    const head = payload[0];
    return head === null || head === void 0 ? void 0 : head.status;
  }

  if (typeof payload === 'object' && !Array.isArray(payload)) {
    return payload.status;
  }

  return undefined;
} // <DTO PROP>: [<SYMPTOM LETTER>, <DISPLAY VALUE>]


export const symptoms = {
  [pain]: ['A', defaults.pain],
  [shortBreath]: ['B', defaults.shortnessOfBreath],
  [anxiety]: ['C', defaults.anxiety],
  [nausea]: ['D', defaults.nausea],
  [vomiting]: ['E', defaults.vomiting],
  [diarrhea]: ['F', defaults.diarrhea],
  [constipation]: ['G', defaults.constipation],
  [agitation]: ['H', defaults.agitation]
}; // <CODE>: <DISPLAY VALUE>

export const symptomCodes = {
  '0': none,
  '1': mild,
  '2': moderate,
  '3': severe,
  '9': notApplicable
}; // <CODE>: <DISPLAY VALUE>

export const docErrorCodes = {
  '0': noError,
  '1': warning,
  '2': error
}; // TODO refactor above maps to this pattern.

export const emptySIA = {
  [pain]: null,
  [shortBreath]: null,
  [anxiety]: null,
  [nausea]: null,
  [vomiting]: null,
  [diarrhea]: null,
  [constipation]: null,
  [agitation]: null
};
export const SIA_SYMPTOM_KEYS = Object.keys(symptoms);
/** Symptom ratings from GET hope/hopepatientsia/get for the SIA form (radio values as strings). */

export const extractSIADataFromHopePatientSia = dto => {
  const result = {};
  SIA_SYMPTOM_KEYS.forEach(key => {
    const value = dto[key];

    if (value != null && value !== '') {
      result[key] = typeof value === 'number' ? String(value) : `${value}`;
    }
  });
  return result;
};
export const isSIADataComplete = SIAData => SIA_SYMPTOM_KEYS.length === 8 && SIA_SYMPTOM_KEYS.every(key => SIAData[key] != null && SIAData[key] !== '');
const milestoneQuestionNumber = 'J2051';
const SFVQuestionNumber = 'J2053';
/** Progress-note addendum text for a completed SIA (same shape as dashboard SIAModal). */

export const buildHopeSIANoteText = (SIAData, currentMilestone, isSFV) => {
  if (!isSIADataComplete(SIAData)) {
    return null;
  }

  const period = isSFV ? defaults.SFVPeriod : defaults.MilestonePeriod;
  const SIAMessage = `${period}${defaults.SIAStatement}`;
  const questionNumber = isSFV ? SFVQuestionNumber : milestoneQuestionNumber;
  const SIAValues = SIA_SYMPTOM_KEYS.map(key => {
    const symptom = symptoms[key] || [];
    return `${symptom[0]}. ${symptom[1]}: ${SIAData[key]}`;
  });
  return `Addendum\n\u2022 ${currentMilestone} ${questionNumber} - ${SIAMessage}\n${SIAValues.join('\n')}`;
};
export const refusedSIAOptions = {
  '1': declined,
  '2': unavailable,
  '3': cantContact,
  '9': noneOfTheAbove
};
export const canDeclinedHopeVisitBeReopened = (milestone, hopePatientData) => {
  if (!(milestone in declinedMilestoneReopenConfigByCode)) {
    return undefined;
  }

  const {
    dtoPropertyKey
  } = declinedMilestoneReopenConfigByCode[milestone];
  const currentStatusLabel = readHopeDtoMilestoneStatus(hopePatientData, dtoPropertyKey);

  if (currentStatusLabel == null || currentStatusLabel === '') {
    return undefined;
  }

  return isPreVisitWaitingStatus(currentStatusLabel);
};
/**
 * accepted attribute can be reopened only if not approved yet
 */

export const canAccptHopeVisitBeReopened = (milestone, hopePatientData) => {
  if (!(milestone in acceptedMilestoneReopenConfigByCode)) {
    return false;
  }

  const data = hopePatientData[acceptedMilestoneReopenConfigByCode[milestone]];
  const isApproved = approvedMilestoneStatuses.includes(data.status);
  return !isApproved;
};

const getStatus = (attribute, map) => Object.entries(map).reduce((seed, pair) => {
  const [hopeStatus, hopeAttribute] = pair;

  if (hopeAttribute.shortName === attribute) {
    seed = hopeStatus;
  }

  if (seed.includes('-SFV')) {
    seed = seed.split('-')[1];
  }

  return seed;
}, '');

const getIDs = obj => Object.values(obj).map(at => at.id); // hope status => accepted attribute/attribute ID / Update action


export const acceptedHopeAttributes = {
  [ADM]: {
    shortName: HAD,
    id: -14,
    status: admitVisitSubmitted
  },
  [`${ADM}-SFV`]: {
    shortName: HADSF,
    id: -17,
    status: admitSFVSubmitted
  },
  [HUV1]: {
    shortName: HUV1,
    id: -15,
    status: huv1NVRSubmitted
  },
  [`${HUV1}-SFV`]: {
    shortName: HU1SF,
    id: -18,
    status: huv1SFVSubmitted
  },
  [HUV2]: {
    shortName: HUV2,
    id: -16,
    status: huv2NVRSubmitted
  },
  [`${HUV2}-SFV`]: {
    shortName: HU2SF,
    id: -19,
    status: huv2SFVSubmitted
  },
  [`SFVRQ`]: {
    shortName: 'SFVRQ',
    id: -26
  }
};
export const acceptedHopeIDs = getIDs(acceptedHopeAttributes); // Attribute => status

export const getAcceptedHopeStatus = status => getStatus(status, acceptedHopeAttributes); // hope status => refused attribute

export const refusedHopeAttributes = {
  [ADM]: {
    shortName: HADD,
    id: -20
  },
  [`${ADM}-SFV`]: {
    shortName: HADSD,
    id: -23
  },
  [HUV1]: {
    shortName: HUV1D,
    id: -21
  },
  [`${HUV1}-SFV`]: {
    shortName: HU1SD,
    id: -24
  },
  [HUV2]: {
    shortName: HUV2D,
    id: -22
  },
  [`${HUV2}-SFV`]: {
    shortName: HU2SD,
    id: -25
  }
};
export const hopeOptions = {
  [INA]: CompleteINA,
  [NVR]: CompleteNVR,
  [SIA]: CompleteSIA,
  [HUV1]: CompleteHUV1,
  [HUV2]: CompleteHUV2,
  [SFV]: RecordSFV,
  [NFV]: NoSFV,
  [download]: Download,
  [approve]: 'Review',
  [unapprove]: Unapprove,
  [accepted]: Accept,
  [rejected]: Reject,
  [unaccept]: RemoveAcceptance,
  [discard]: Discard
}; // Action => CMS status based on milestone

export const hopeCMSAcceptanceStatuses = {
  [ADM]: {
    [NFV]: admitSFVSubmitted,
    [approve]: admitApproved,
    [unapprove]: admitUnApproved,
    [download]: admitDownloaded,
    [accepted]: admitCMSAccepted,
    [rejected]: admitCMSRejected,
    [unaccept]: admitCMSUnaccepted
  },
  [HUV1]: {
    [NFV]: huv1SFVSubmitted,
    [approve]: huv1Approved,
    [unapprove]: huv1UnApproved,
    [download]: huv1Downloaded,
    [accepted]: huv1CMSAccepted,
    [rejected]: huv1CMSRejected,
    [unaccept]: huv1CMSUnaccepted,
    [discard]: huv1Discarded
  },
  [HUV2]: {
    [NFV]: huv2SFVSubmitted,
    [approve]: huv2Approved,
    [unapprove]: huv2UnApproved,
    [download]: huv2Downloaded,
    [accepted]: huv2CMSAccepted,
    [rejected]: huv2CMSRejected,
    [unaccept]: huv2CMSUnaccepted,
    [discard]: huv2Discarded
  },
  [DIS]: {
    [NFV]: '',
    [approve]: dischargeApproved,
    [unapprove]: dischargeUnApproved,
    [download]: dischargeDownloaded,
    [accepted]: dischargeCMSAccepted,
    [rejected]: dischargeCMSRejected,
    [unaccept]: dischargeCMSUnaccepted
  }
};
export const hopeDocumentProps = {
  [ADM]: isForAdmit,
  [HUV1]: isForHUV1,
  [HUV2]: isForHUV2,
  [DIS]: isForDischarge
};
/** ADM / HUV1 / HUV2 (and *-SFV variants) for pre-submit hopereport validation. */

export const getHopePreSubmitMilestoneType = currentMilestone => {
  if (!currentMilestone) {
    return null;
  }

  const postMilestone = currentMilestone.split('-')[0];

  if (postMilestone === ADM || postMilestone === HUV1 || postMilestone === HUV2) {
    return postMilestone;
  }

  return null;
};
const HOPE_SFV_ONLY_BLOCKING_ITEMS = new Set(['J2052A', 'J2052B', 'J2052C', 'J2053A', 'J2053B', 'J2053C', 'J2053D', 'J2053E', 'J2053F', 'J2053G', 'J2053H']);
/** Same rules as HOPE approve: visible rows for milestone with CMS error level. */

export const getHopeBlockingErrors = (reportRows, hopeDTOProp, isSFV = false) => {
  if (!(reportRows !== null && reportRows !== void 0 && reportRows.length) || !hopeDTOProp) {
    return [];
  }

  return reportRows.filter(row => (row === null || row === void 0 ? void 0 : row.balwayshide) !== 'true' && row[hopeDTOProp] !== 'false' && row.errorlevel === 2 && (isSFV || !HOPE_SFV_ONLY_BLOCKING_ITEMS.has(row === null || row === void 0 ? void 0 : row.itemnumber)));
};
export const refusedHopeIDs = getIDs(refusedHopeAttributes); // Attribute => status

export const getRefusedHopeStatus = status => getStatus(status, refusedHopeAttributes); // reduce over the different milestones and collect available actions.
// First in the list will be the current.

export const getAvailableMilestones = (hopeData, appVisit) => hopeKeys.reduce((seed, key) => {
  const event = hopeData && hopeData[key];

  if (!event) {
    return seed;
  } // search each event's actions for one of the milestones


  const hasMilestone = event.possibleactions && event.possibleactions.find(action => hopeMilestones.find(milestone => {
    const parsedAction = action;
    return parsedAction.actn === milestone;
  }));
  const visitRole = appVisit.careProviderRole || appVisit.roleshortname;

  if ((hasMilestone === null || hasMilestone === void 0 ? void 0 : hasMilestone.actn) === SFV) {
    // only Nurse rolegroup for SFV visits
    if (appVisit.careProviderRoleGroup !== 'Nurse') {
      return seed;
    } // if SFV add 'milestone-SFV'


    const string = `${event.milestone}-${hasMilestone.actn}`;
    const value = seed.milestone.length && `,${string}` || string;
    seed.milestone = seed.milestone.concat(value);
    seed.visitid = event.patientvisit_id;
    seed.status = event.status;
    seed.visitEligibleFrom = event.visitEligibleFrom;
    seed.visit_in_progress = event.visit_in_progress;
    seed.key = key;
  } else if (hasMilestone) {
    // Only RN role for milestone visits
    if (visitRole !== 'RN') {
      return seed;
    }

    const value = seed.milestone.length && `,${event.milestone}` || event.milestone;
    seed.milestone = seed.milestone.concat(value);
    seed.visitid = event.patientvisit_id;
    seed.status = event.status;
    seed.visitEligibleFrom = event.visitEligibleFrom;
    seed.visit_in_progress = event.visit_in_progress;
    seed.key = key;
  }

  return seed;
}, {
  milestone: '',
  visitid: null,
  status: null,
  visitEligibleFrom: null,
  visit_in_progress: null,
  key: ''
});
/** Visit attribute shortname for “SFV required” paired with admit / HUV milestones. */

export const HOPE_SFV_REQUIRED_ATTRIBUTE_SHORTNAME = 'SFVRQ';

const milestoneDtoKeyFromMilestoneKey = milestoneKey => {
  const base = milestoneKey.split('-')[0];
  if (base === ADM) return AdmitData;
  if (base === HUV1) return HUV1Data;
  if (base === HUV2) return HUV2Data;
  return null;
};

const milestoneKeyFromAcceptedAttributes = primaryShortname => {
  switch (primaryShortname) {
    case HAD:
      return ADM;

    case HADSF:
      return `${ADM}-${SFV}`;

    case HUV1:
      return HUV1;

    case HU1SF:
    case 'HUV1SF':
      return `${HUV1}-${SFV}`;

    case HUV2:
      return HUV2;

    case HU2SF:
    case 'HUV2SF':
      return `${HUV2}-${SFV}`;

    default:
      return null;
  }
};

const milestoneKeyFromRefusedAttributes = primaryShortname => {
  switch (primaryShortname) {
    case HADD:
      return ADM;

    case HADSD:
      return `${ADM}-${SFV}`;

    case HUV1D:
      return HUV1;

    case HU1SD:
      return `${HUV1}-${SFV}`;

    case HUV2D:
      return HUV2;

    case HU2SD:
      return `${HUV2}-${SFV}`;

    default:
      return null;
  }
};
/**
 * HOPE milestone key string (e.g. `ADM`, `HUV1-SFV`) from visit attribute summaries,
 * used when reopening a completed visit so we do not rely on `getAvailableMilestones`
 * (role / action matching can be wrong after hydrate).
 * SFVRQ only flags that an SFV is required; it never changes the visit's milestone.
 */


export const getHopeMilestoneKeyStringFromReopenVisitAttributes = (acceptedAtts, refusedAtts) => {
  if (acceptedAtts !== null && acceptedAtts !== void 0 && acceptedAtts.length) {
    var _acceptedAtts$;

    const primary = (_acceptedAtts$ = acceptedAtts[0]) === null || _acceptedAtts$ === void 0 ? void 0 : _acceptedAtts$.shortname;
    if (!primary) return null;
    return milestoneKeyFromAcceptedAttributes(primary);
  }

  if (refusedAtts !== null && refusedAtts !== void 0 && refusedAtts.length) {
    var _refusedAtts$;

    const primary = (_refusedAtts$ = refusedAtts[0]) === null || _refusedAtts$ === void 0 ? void 0 : _refusedAtts$.shortname;
    if (!primary) return null;
    return milestoneKeyFromRefusedAttributes(primary);
  }

  return null;
};
/**
 * `getAvailableMilestones`-shaped payload for a reopened visit when the milestone
 * is taken from visit attributes instead of HOPE action matching.
 */

export const buildComputedMilestonesResForHopeReopen = (hopeStatus, appVisit, milestoneKey) => {
  var _appVisit$id, _ref, _appVisit$effectiveda, _visitEligibleFrom;

  const dtoKey = milestoneDtoKeyFromMilestoneKey(milestoneKey);
  let status = '';
  let visitEligibleFrom = null;
  let visitid = (_appVisit$id = appVisit === null || appVisit === void 0 ? void 0 : appVisit.id) !== null && _appVisit$id !== void 0 ? _appVisit$id : null;

  if (dtoKey && hopeStatus) {
    const block = hopeStatus[dtoKey];
    const arr = Array.isArray(block) ? block : null;
    const head = arr === null || arr === void 0 ? void 0 : arr[0];

    if (head) {
      var _head$visitEligibleFr;

      status = head.status != null ? String(head.status) : '';
      visitEligibleFrom = (_head$visitEligibleFr = head.visitEligibleFrom) !== null && _head$visitEligibleFr !== void 0 ? _head$visitEligibleFr : null;

      if (head.patientvisit_id != null && head.patientvisit_id !== '') {
        visitid = head.patientvisit_id;
      }
    }
  }

  const fallbackDate = (_ref = (_appVisit$effectiveda = appVisit === null || appVisit === void 0 ? void 0 : appVisit.effectivedatetime) !== null && _appVisit$effectiveda !== void 0 ? _appVisit$effectiveda : appVisit === null || appVisit === void 0 ? void 0 : appVisit.startDate) !== null && _ref !== void 0 ? _ref : null;
  return {
    milestone: milestoneKey,
    visitid,
    status,
    visitEligibleFrom: (_visitEligibleFrom = visitEligibleFrom) !== null && _visitEligibleFrom !== void 0 ? _visitEligibleFrom : fallbackDate,
    visit_in_progress: null
  };
}; // retruns the first milestone

export const getCurrentMilestone = patientMilestones => (patientMilestones === null || patientMilestones === void 0 ? void 0 : patientMilestones.includes(',')) && (patientMilestones === null || patientMilestones === void 0 ? void 0 : patientMilestones.split(',')[0]) || patientMilestones;
export const visitHasHopeDoc = (currentMilestone, forms) => {
  const keys = currentMilestone === ADM ? HopeADMFormKeys : HopeHUVFormKeys;
  return forms && JSON.parse(forms).find(form => keys.find(hopeFormKey => {
    var _form$formkey;

    return form === null || form === void 0 ? void 0 : (_form$formkey = form.formkey) === null || _form$formkey === void 0 ? void 0 : _form$formkey.includes(hopeFormKey);
  })) || null;
};
export const getHopeSIADTO = (patient, SIAData, milestone, siaDone, sfvDone, notDoneReason, patientVisitId) => _objectSpread(_objectSpread({}, SIAData), {}, {
  patientId: `${patient.id}`,
  patientNumber: patient.patientNumber || patient.patientnumber || patient.patientNumber,
  episodeNum: `${patient.episodes ? patient.episodes.length - 1 : patient.episodeNum}`,
  milestone: sfvDone ? milestone === null || milestone === void 0 ? void 0 : milestone.split('-')[0] : milestone,
  effectiveDateUtc: formatPostDate(new Date()),
  siaDone,
  sfvDone,
  notDoneReason,
  patientVisitId
});
/** True when GET hope/hopepatientsia/get returned HOPESymptomImpactDTO with an id (include on POST for update). */

export const hopePatientSiaRow = existing => {
  if (!existing || existing instanceof Response) {
    return null;
  }

  const row = Array.isArray(existing) ? existing[0] : existing;

  if (!row || typeof row !== 'object') {
    return null;
  }

  return row;
};
export const hopePatientSiaExists = existing => {
  const row = hopePatientSiaRow(existing);

  if (!row) {
    return false;
  }

  const {
    id
  } = row;
  return id != null && id !== '' && Number(id) !== 0;
};
export const mergeHopePatientSiaForUpdate = (existing, SIADTO) => {
  var _prior$id;

  const prior = hopePatientSiaRow(existing) || {};
  return _objectSpread(_objectSpread(_objectSpread({}, prior), SIADTO), {}, {
    id: (_prior$id = prior.id) !== null && _prior$id !== void 0 ? _prior$id : SIADTO.id
  });
};
export const normalizeHopeSiaMilestone = milestone => `${milestone !== null && milestone !== void 0 ? milestone : ''}`.split('-')[0];
export const hopeSiaMilestoneMatches = (storedMilestone, currentMilestone) => {
  const normalizedStored = normalizeHopeSiaMilestone(storedMilestone);
  const normalizedCurrent = normalizeHopeSiaMilestone(currentMilestone);
  return normalizedStored !== '' && normalizedCurrent !== '' && normalizedStored === normalizedCurrent;
};
export const hopePatientSiaVisitIdMatches = (existing, patientVisitId) => {
  var _row$patientVisitId;

  const row = hopePatientSiaRow(existing);

  if (!row || patientVisitId == null || `${patientVisitId}` === '') {
    return false;
  }

  const storedVisitId = (_row$patientVisitId = row.patientVisitId) !== null && _row$patientVisitId !== void 0 ? _row$patientVisitId : row.patientvisit_id;
  return `${storedVisitId !== null && storedVisitId !== void 0 ? storedVisitId : ''}` === `${patientVisitId}`;
};
export const siaDtoToSymptomData = row => {
  const result = {};
  Object.keys(emptySIA).forEach(key => {
    const value = row[key];

    if (value != null && value !== '') {
      result[key] = `${value}`;
    }
  });
  return result;
};
/** Matches structured HOPE/SIA addenda produced by buildHopeSIANoteText. */

const HOPE_ADDENDUM_HEADER_REGEX = /^Addendum[\s\n]+[•\u2022]\s*([A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)/;
/**
 * Returns a normalized milestone group key for structured HOPE addendum notes
 * (e.g. HUV1-SFV → HUV1), or null when the note is not that format.
 */

export const getHopeAddendumGroupKey = noteText => {
  if (!noteText) return null;
  const match = noteText.trimStart().match(HOPE_ADDENDUM_HEADER_REGEX);
  if (!match) return null;
  return match[1].replace(/-SFV$/i, '');
};
/**
 * Keeps the first progress note per HOPE addendum milestone group; all other
 * notes (including free-text addenda) are preserved unchanged.
 */

export const dedupeHopeAddendumProgressNotes = notes => {
  if (!(notes !== null && notes !== void 0 && notes.length)) return notes !== null && notes !== void 0 ? notes : [];
  const seenKeys = new Set();
  return notes.filter(note => {
    const key = getHopeAddendumGroupKey(note.note);
    if (!key) return true;
    if (seenKeys.has(key)) return false;
    seenKeys.add(key);
    return true;
  });
};

const getAttribute = (currentMilestone, visitAttributes, map) => {
  const at = map[currentMilestone];
  const attributeID = at && at.id || '';
  return visitAttributes.find(att => att.id === attributeID);
}; // update two atributes at a time, in the positive and negative for each hope milestone.
// status = true => milestone happened, status = false => milestone didn't


export const removeVisitAttribute = visitAttributes => {
  if (!visitAttributes) return;
  Object.keys(acceptedHopeAttributes).forEach(att => {
    const selectedAcceptedAttribute = getAttribute(att, visitAttributes, acceptedHopeAttributes);
    selectedAcceptedAttribute.isSelected = false;
  });
  Object.keys(refusedHopeAttributes).forEach(att => {
    const selectedRefusedAttribute = getAttribute(att, visitAttributes, refusedHopeAttributes);
    selectedRefusedAttribute.isSelected = false;
  });
  return visitAttributes;
}; // update two atributes at a time, in the positive and negative for each hope milestone.
// status = true => milestone happened, status = false => milestone didn't

export const updateHopeVisitAttribute = (visitAttributes, currentMilestone, status) => {
  if (!visitAttributes) return;
  removeVisitAttribute(visitAttributes);
  const selectedAcceptedAttribute = getAttribute(currentMilestone, visitAttributes, acceptedHopeAttributes);
  const selectedRefusedAttribute = getAttribute(currentMilestone, visitAttributes, refusedHopeAttributes);

  if (status) {
    // milestone did happen
    selectedAcceptedAttribute.isSelected = true;
    selectedRefusedAttribute.isSelected = false;
  } else {
    // milestone didn't happen
    selectedAcceptedAttribute.isSelected = false;
    selectedRefusedAttribute.isSelected = true;
  }

  return status ? selectedAcceptedAttribute : selectedRefusedAttribute;
};
/** True when any SIA symptom scores 2–7. An SFV milestone never requires another SFV. */

export const siaRequiresSfv = (SIAData, milestone) => !milestone.includes(`-${SFV}`) && Object.values(SIAData || {}).some(symptom => symptom >= 2 && symptom < 8);
/** Whether the SFVRQ visit attribute is currently selected. */

export const isVisitSFVRequired = visitAttributes => {
  var _visitAttributes$find;

  return !!(visitAttributes !== null && visitAttributes !== void 0 && (_visitAttributes$find = visitAttributes.find(att => att.id === -26)) !== null && _visitAttributes$find !== void 0 && _visitAttributes$find.isSelected);
};
export const updateVisitSFVRequired = (visitAttributes, status) => {
  if (!visitAttributes) return;
  const selectedAttribute = visitAttributes.find(att => att.id === -26);

  if (selectedAttribute) {
    selectedAttribute.isSelected = status;
  }

  return visitAttributes;
};
export const parseActions = data => data.map(row => {
  hopeKeys.forEach(key => {
    var _row$key;

    const actions = (_row$key = row[key]) === null || _row$key === void 0 ? void 0 : _row$key.possibleactions;

    if (actions) {
      row[key].possibleactions = actions.map(a => JSON.parse(a));
    }
  });
  return row;
});
/*
  check if action is in list of actions
*/

export const actionIsAvailable = (possibleActions, actionToFind) => actionToFind && possibleActions && possibleActions.find(action => action.actn === actionToFind);
/*
  This function returns the first milestone with supplied action
*/

export const getMilestoneByAction = (hopeData, actionToFind) => !!hopeData && hopeKeys.reduce((seed, key) => {
  var _hopeData$key;

  const possibleActions = (_hopeData$key = hopeData[key]) === null || _hopeData$key === void 0 ? void 0 : _hopeData$key.possibleactions;
  const milestone = !!possibleActions && possibleActions.find(action => action.actn === actionToFind);

  if (seed === '' && milestone) {
    var _hopeData$key2;

    seed = (_hopeData$key2 = hopeData[key]) === null || _hopeData$key2 === void 0 ? void 0 : _hopeData$key2.milestone;
  }

  return seed;
}, '') || null;
/*
  This function returns the first milestone with an 'approve' action
*/

export const getApprovalMilestone = hopeData => !!hopeData && hopeKeys.reduce((seed, key) => {
  var _hopeData$key3, _hopeData$key4, _hopeData$key4$possib;

  const milestone = !!((_hopeData$key3 = hopeData[key]) !== null && _hopeData$key3 !== void 0 && _hopeData$key3.possibleactions) && ((_hopeData$key4 = hopeData[key]) === null || _hopeData$key4 === void 0 ? void 0 : (_hopeData$key4$possib = _hopeData$key4.possibleactions) === null || _hopeData$key4$possib === void 0 ? void 0 : _hopeData$key4$possib.find(action => action.actn === approve));

  if (seed === '' && milestone) {
    var _hopeData$key5;

    seed = (_hopeData$key5 = hopeData[key]) === null || _hopeData$key5 === void 0 ? void 0 : _hopeData$key5.milestone;
  }

  return seed;
}, '') || null;
/* 
  This function searches through a patient's visit history to return
  the visit ID and form ID for a HOPE milestone visit.
*/

export const getHopeFormInfo = (currentMilestone, completedPatientForms, patientVisitHistory, formKeys) => {
  if (!currentMilestone || !patientVisitHistory) {
    return null;
  }

  const mileStone = currentMilestone.split('-')[0];
  const hopeAttribute = acceptedHopeAttributes[mileStone];
  const hopeVisit = patientVisitHistory.find(visit => {
    let attributes = []; // Visit data can have multiple prop names for attributes.
    // parse before using if needed

    if (visit.visitAttributes && typeof visit.visitAttributes === 'string') {
      attributes = JSON.parse(visit.visitAttributes);
    } else if (visit.visitAttributes) {
      attributes = visit.visitAttributes;
    } else if (typeof visit.visitattrsumdto === 'string') {
      attributes = JSON.parse(visit.visitattrsumdto);
    } // Same with 'isSelected' vs 'isselected' (visitattrsumdto uses lowercase)


    return attributes && attributes.find(att => (att === null || att === void 0 ? void 0 : att.id) === (hopeAttribute === null || hopeAttribute === void 0 ? void 0 : hopeAttribute.id) && ((att === null || att === void 0 ? void 0 : att.isSelected) || (att === null || att === void 0 ? void 0 : att.isselected)));
  });

  if (!hopeVisit) {
    return null;
  }

  const hopeForm = completedPatientForms.find(form => form.patientvisit_id === `${hopeVisit.id}` && formKeys.find(hopeFormKey => form.formkey.includes(hopeFormKey)));

  if (!hopeForm) {
    return null;
  }

  return {
    visitId: hopeVisit === null || hopeVisit === void 0 ? void 0 : hopeVisit.id,
    formId: hopeForm.id,
    formName: hopeForm.formname,
    patientNumber: hopeForm.patientnumber
  };
};

const parseVisitAttributesJson = visitattrsumdto => {
  if (!visitattrsumdto) {
    return null;
  }

  if (Array.isArray(visitattrsumdto)) {
    return visitattrsumdto;
  }

  if (typeof visitattrsumdto !== 'string') {
    return null;
  }

  try {
    const parsed = JSON.parse(visitattrsumdto);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

const filterSortAcceptedHopeAtts = visitAttributes => visitAttributes.filter(visitAtt => acceptedHopeIDs.find(hopeAtt => hopeAtt === visitAtt.id && isVisitAttributeSelected(visitAtt))).sort((a, b) => a.id > b.id && -1 || 1);

const filterSortRefusedHopeAtts = visitAttributes => visitAttributes.filter(visitAtt => refusedHopeIDs.find(hopeAtt => hopeAtt === visitAtt.id && isVisitAttributeSelected(visitAtt))).sort((a, b) => a.id > b.id && -1 || 1);
/** Accepted HOPE visit attributes only (skip refused work when visit-log UI does not need it). */


export const getAcceptedHopeAttributes = visitattrsumdto => {
  const visitAttributes = parseVisitAttributesJson(visitattrsumdto);

  if (!visitAttributes) {
    return [];
  }

  return filterSortAcceptedHopeAtts(visitAttributes);
};
/** Accepted and refused HOPE attrs from visitattrsumdto JSON or array (visit-log parity). */

export const getHopeAttributes = visitattrsumdto => {
  const visitAttributes = parseVisitAttributesJson(visitattrsumdto);

  if (!visitAttributes) {
    return [[], []];
  }

  return [filterSortAcceptedHopeAtts(visitAttributes), filterSortRefusedHopeAtts(visitAttributes)];
};
/**
 * Election Addendum state of a visit from visitattrsumdto JSON or array (visit-log EA column).
 * EAC (created) wins over EAO (offered).
 */

export const getElectionAddendumVisitStatus = visitattrsumdto => {
  const visitAttributes = parseVisitAttributesJson(visitattrsumdto);

  if (hasSelectedVisitAttribute(visitAttributes, EAC)) {
    return 'created';
  }

  if (hasSelectedVisitAttribute(visitAttributes, EAO)) {
    return 'offered';
  }

  return null;
};
export const getVisitHopeAttributes = visitattrsumdto => {
  const acceptedHopeAtts = getAcceptedHopeAttributes(visitattrsumdto);

  if (acceptedHopeAtts.length) {
    return true;
  }

  return null;
};
export const visitHasHopeAttribute = visit => {
  const acceptedHopeVisitAtt = Object.values(acceptedHopeAttributes).find(att => visit === null || visit === void 0 ? void 0 : visit.visitAttributes.find(visitAtt => att.id === visitAtt.id && visitAtt.isSelected));
  const rejectedHopeVisitAtt = Object.values(refusedHopeAttributes).find(att => visit === null || visit === void 0 ? void 0 : visit.visitAttributes.find(visitAtt => att.id === visitAtt.id && visitAtt.isSelected));

  if (acceptedHopeVisitAtt) {
    return true;
  } else if (rejectedHopeVisitAtt) {
    return false;
  }

  return null;
};
/** HOPE yes/no for a reopened visit when attrs may be on visitAttributes or visitattrsumdto. */

export const resolveHopeVisitDecisionForReopen = appVisit => {
  var _ref2, _appVisit$visitAttrib;

  const fromSelected = visitHasHopeAttribute(appVisit);

  if (fromSelected !== null) {
    return fromSelected;
  }

  const attrSource = (_ref2 = (_appVisit$visitAttrib = appVisit === null || appVisit === void 0 ? void 0 : appVisit.visitAttributes) !== null && _appVisit$visitAttrib !== void 0 ? _appVisit$visitAttrib : appVisit === null || appVisit === void 0 ? void 0 : appVisit.visitattrsumdto) !== null && _ref2 !== void 0 ? _ref2 : null;
  const [acceptedAtts, refusedAtts] = getHopeAttributes(attrSource);

  if (acceptedAtts.length) {
    return true;
  }

  if (refusedAtts.length) {
    return false;
  }

  return null;
};
export const removeExtraData = hopeData => hopeData.map(events => {
  const huv1 = events[HUV1Data];
  const huv2 = events[HUV2Data];

  if (!!huv1 && (events === null || events === void 0 ? void 0 : events.dayofservice) <= 5) {
    events[HUV1Data] = {
      dos: 0,
      effectivedate_shifted: null,
      effectivedate_utc: null,
      status: null,
      statusmessage: null,
      milestone: null,
      possibleactions: null,
      numerrors: null,
      numwarnings: null
    };
  }

  if (!!huv2 && (events === null || events === void 0 ? void 0 : events.dayofservice) <= 15) {
    events[HUV2Data] = {
      dos: 0,
      effectivedate_shifted: null,
      effectivedate_utc: null,
      status: null,
      statusmessage: null,
      milestone: null,
      possibleactions: null,
      numerrors: null,
      numwarnings: null
    };
  }

  return events;
});
/** Marker shown on collapsed post–HUV2 Complete trail rows. */

export const HopeCollapsedEllipsis = '...';

const blankHopeMilestone = (overrides = {}) => _objectSpread({
  dos: 0,
  effectivedate_shifted: null,
  effectivedate_utc: null,
  status: null,
  statusmessage: null,
  milestone: null,
  possibleactions: null,
  numerrors: null,
  numwarnings: null,
  reportDownloadAvailable: false,
  visit_in_progress: null,
  sfv_in_progress: null
}, overrides);
/** True when the row is only the post–HUV2 Complete filler (no discharge activity). */


const isPostHuv2CompleteTrailRow = row => {
  var _row$huv2data, _row$dischargedata;

  if ((row === null || row === void 0 ? void 0 : (_row$huv2data = row.huv2data) === null || _row$huv2data === void 0 ? void 0 : _row$huv2data.status) !== 'Complete') return false;
  if (row !== null && row !== void 0 && (_row$dischargedata = row.dischargedata) !== null && _row$dischargedata !== void 0 && _row$dischargedata.status) return false;
  return true;
};
/**
 * After HUV2 reaches "Sent and Accepted", drop consecutive Complete-only days and
 * replace them with one ellipsis row (Day = last trail / "today" DOS). HUV2
 * `unaccept` from the last Complete day is kept on that ellipsis row.
 */


export const collapsePostHuv2CompleteTrail = hopeData => {
  var _lastHuv2$possibleact, _lastHuv2$reportDownl, _lastHuv2$visitEligib;

  if (!(hopeData !== null && hopeData !== void 0 && hopeData.length)) return hopeData;
  let lastSentAcceptedIdx = -1;

  for (let i = hopeData.length - 1; i >= 0; i -= 1) {
    var _hopeData$i, _hopeData$i$huv2data;

    if (((_hopeData$i = hopeData[i]) === null || _hopeData$i === void 0 ? void 0 : (_hopeData$i$huv2data = _hopeData$i.huv2data) === null || _hopeData$i$huv2data === void 0 ? void 0 : _hopeData$i$huv2data.status) === 'Sent and Accepted') {
      lastSentAcceptedIdx = i;
      break;
    }
  }

  if (lastSentAcceptedIdx < 0) return hopeData;
  let trailEnd = lastSentAcceptedIdx;

  for (let i = lastSentAcceptedIdx + 1; i < hopeData.length; i += 1) {
    if (!isPostHuv2CompleteTrailRow(hopeData[i])) break;
    trailEnd = i;
  }

  if (trailEnd === lastSentAcceptedIdx) return hopeData;
  const kept = hopeData.slice(0, lastSentAcceptedIdx + 1);
  const lastComplete = hopeData[trailEnd];
  const remainder = hopeData.slice(trailEnd + 1);
  const {
    dayofservice
  } = lastComplete;
  const lastHuv2 = lastComplete.huv2data;

  const ellipsisRow = _objectSpread(_objectSpread({}, lastComplete), {}, {
    collapsedEllipsis: true,
    effectivedate_shifted: lastComplete.effectivedate_shifted,
    admitdata: blankHopeMilestone({
      dos: dayofservice,
      status: HopeCollapsedEllipsis,
      statusmessage: HopeCollapsedEllipsis,
      milestone: ADM
    }),
    huv1Data: blankHopeMilestone({
      dos: dayofservice,
      milestone: HUV1
    }),
    huv2data: blankHopeMilestone({
      dos: dayofservice,
      // Keep Complete so Due stays hidden (same as other Complete days).
      status: 'Complete',
      statusmessage: HopeCollapsedEllipsis,
      milestone: HUV2,
      possibleactions: (_lastHuv2$possibleact = lastHuv2 === null || lastHuv2 === void 0 ? void 0 : lastHuv2.possibleactions) !== null && _lastHuv2$possibleact !== void 0 ? _lastHuv2$possibleact : null,
      reportDownloadAvailable: (_lastHuv2$reportDownl = lastHuv2 === null || lastHuv2 === void 0 ? void 0 : lastHuv2.reportDownloadAvailable) !== null && _lastHuv2$reportDownl !== void 0 ? _lastHuv2$reportDownl : true,
      visitEligibleFrom: (_lastHuv2$visitEligib = lastHuv2 === null || lastHuv2 === void 0 ? void 0 : lastHuv2.visitEligibleFrom) !== null && _lastHuv2$visitEligib !== void 0 ? _lastHuv2$visitEligib : null
    }),
    dischargedata: blankHopeMilestone()
  });

  return [...kept, ellipsisRow, ...remainder];
};
/**
 * Normalizes `getHopePatientDetails` API rows for `HopeGlobalContext` `SET_HOPE_DETAIL`.
 */

export const buildHopePatientDetailPayload = hopeDetailData => {
  const collapsed = collapsePostHuv2CompleteTrail(removeExtraData(hopeDetailData));
  const {
    length
  } = collapsed;
  return collapsed.map(dto => _objectSpread(_objectSpread({}, dto), {}, {
    currentdayofservice: length
  }));
};
export const filterHopeListByAction = (hopeData, action) => hopeData.reduce((seed, data) => {
  const milestoneToDownload = getMilestoneByAction(data, action);

  if (milestoneToDownload) {
    const newData = _objectSpread({}, data);

    Object.entries(milestonesDTOProps).forEach(([key, value]) => {
      if (milestoneToDownload !== key) {
        newData[value] = {
          dos: 0,
          effectivedate_shifted: null,
          effectivedate_utc: null,
          status: null,
          statusmessage: null,
          milestone: null,
          possibleactions: null,
          numerrors: null,
          numwarnings: null
        };
      }
    });
    seed.push(newData);
  }

  return seed;
}, []);
export const getHopeDocName = milestone => {
  if (!milestone) {
    return '';
  }

  const u = milestone.toUpperCase();

  if (u.includes(ADM)) {
    return INAForm;
  }

  if (u.includes(HUV1) || u.includes(HUV2)) {
    return NVRForm;
  }

  return '';
};
/**
 * Returns true if the required-questions toggle must be locked (hidden) for a
 * HOPE INA or NVR form based on the visit it was submitted against.
 *
 * Uses ID-based attribute lookup against pimreader visitattrsumdto JSON, which
 * uses lowercase `isselected` — different from the typed Visit.visitAttributes
 * shape used by checkVisitAttribute.
 *
 * INA locked when the visit has HAD (id -14) selected.
 * NVR locked when the visit has HUV1 (id -15) or HUV2 (id -16) selected.
 */

export const isHopeRequiredToggleLocked = (formName, visitattrsumdto) => {
  const attrs = getAcceptedHopeAttributes(visitattrsumdto);
  if (!attrs.length) return false;

  if (formName.includes(INAForm)) {
    return attrs.some(a => a.id === acceptedHopeAttributes[ADM].id);
  }

  if (formName.includes(NVRForm)) {
    return attrs.some(a => a.id === acceptedHopeAttributes[HUV1].id || a.id === acceptedHopeAttributes[HUV2].id);
  }

  return false;
};